import { useAppLocale } from '@/i18n/context';
import { workspaceTextFor } from '../../interface-copy';
import { formatNumber } from '../money.ts';

export const rowsLabel = (count: number, locale = 'en') =>
  workspaceTextFor(locale)(count === 1 ? '{count} row' : '{count} rows', {
    count: formatNumber(count, locale),
  });

export function tableCopyFor(locale: string) {
  const text = workspaceTextFor(locale);
  return {
    search: text('Search rows'),
    filter: text('Filter'),
    clearFilters: text('Clear filters'),
    sort: text('Sort'),
    sortBy: (column: string) => text('Sort: {column}', { column }),
    rowCount: (shown: number, total: number) =>
      shown === total
        ? rowsLabel(total, locale)
        : text('{shown} of {total} rows', {
            shown: formatNumber(shown, locale),
            total: formatNumber(total, locale),
          }),
    more: text('More'),
    density: text('Density'),
    comfortable: text('Comfortable'),
    compact: text('Compact'),
    columns: text('Columns'),
    noMatch: text('No rows match. Clear the search or filters to see them again.'),
    notAvailable: text('Not available'),
    allRows: text('All rows'),
    closeDetail: text('Close row detail'),
    askAboutRow: text('Ask about this row'),
    addNote: text('Add note'),
    note: text('Note'),
    saved: text('Saved'),
    total: text('Total'),
    ascending: text('ascending'),
    descending: text('descending'),
    tableLabel: text('Table'),
    scrollColumns: text('Scroll to see all columns'),
  };
}

export function useTableCopy() {
  return tableCopyFor(useAppLocale());
}
